<template>
  <dd-header-card header="Kies een actie die je wil automatiseren">
    <div class="flex-row gap-sm">
      <dd-card
          @click="sendEmail"
          :active="send_email || type === 'campaign'"
          :nested="true"
      >
        <div class="flex-col justify-content-center align-items-center">
          <EmailIcon class="icon-size-xl"/>
          <span>E-mail versturen</span>
        </div>
      </dd-card>
      <dd-card
          @click="createSignal"
          :active="create_signal"
          :nested="true">
        <div class="flex-col justify-content-center align-items-center">
          <BellIcon class="icon-size-xl"/>
          <span>Signaal aanmaken</span>
        </div>
      </dd-card>
      <dd-card
          :active="create_task"
          @click="createTask"
          :nested="true">
        <div class="flex-col justify-content-center align-items-center">
          <CheckboxOutlineIcon class="icon-size-xl"/>
          <span>Taak aanmaken</span>
        </div>
      </dd-card>
    </div>
  </dd-header-card>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";

export default {
  name: "ChooseAutomationActions",
  computed: {
    ...mapFields(`$_automation`, [
      'creatingAutomation.create_task',
      'creatingAutomation.create_signal',
      'creatingAutomation.send_email',
    ]),
    ...mapState('$_automation', {
      type: state => state.creatingAutomation.type,
    }),
  },
  methods: {
    createTask() {
      this.create_task = !this.create_task;
    },
    createSignal() {
      this.create_signal = !this.create_signal;
    },
    sendEmail() {
      this.send_email = !this.send_email;
    },
  }
};
</script>

<style scoped>

</style>
